import { create } from "zustand";
import { combine } from "zustand/middleware";

export const useApp = create(
  combine(
    {
      isSheetMenuOpen: false,
      isBalanceValueHidden: false,
    },

    (set, get) => ({
      setIsSheetMenuOpen: (value: boolean) => set({ isSheetMenuOpen: value }),
      toggleBalanceValue: () =>
        set({
          isBalanceValueHidden: !get().isBalanceValueHidden,
        }),
    }),
  ),
);
